import { httpgst, http } from '../../main'
import { store } from '../../store'

const actions = {
  getLogged ({commit, dispatch}, payload) {
    let url = 'api/user-logged'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.defaults.headers.common['X-device'] = 'WEB'
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetLogged', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  companiesGet ({commit, dispatch}, payload) {
    let url = 'api/company'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, options, {})
      .then(
        response => {
          commit('onCompaniesGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  categoriesGet ({commit, dispatch}, payload) {
    let url = 'api/categories'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, options, {})
      .then(
        response => {
          commit('onCategoriesGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  restrictionTypesGet ({commit, dispatch}, payload) {
    let url = 'api/catalog/gst_restriction_types'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, options, {})
      .then(
        response => {
          commit('onRestrictionTypesGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  currencyGet ({commit, dispatch}, payload) {
    let url = 'api/sat/moneda'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, options, {})
      .then(
        response => {
          commit('onCurrencyGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  paymentGet ({commit, dispatch}, payload) {
    let url = 'api/sat/forma-pago'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, options, {})
      .then(
        response => {
          commit('onPaymentGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  restrictionsGet ({commit, dispatch}, payload) {
    let url = 'api/restrictions'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onRestrictionsGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  restrictionsPost ({commit, dispatch}, payload) {
    let url = 'api/restrictions'
    let areas = []
    let projects = []
    let categories = []
    if (payload.event.item.areas) {
      payload.event.item.areas.map(area => {
        areas.push({gst_area_id: area})
      })
    } else {
      areas = undefined
    }
    if (payload.event.item.projects) {
      payload.event.item.projects.map(project => {
        projects.push({core_project_id: project})
      })
    } else {
      projects = undefined
    }

    if (payload.event.item.gst_category_id) {
      payload.event.item.gst_category_id.map(category => {
        categories.push({gst_category_id: category})
      })
    }

    let params = {
      'company_id': payload.event.item.company_id,
      'gst_areas_id': areas,
      'core_projects_id': projects,
      'gst_restrictions_type_id': payload.event.item.gst_restrictions_type_id,
      'gst_categories_id': categories,
      'name': payload.event.item.name,
      'value': payload.event.item.value,
      'is_warning': payload.event.item.is_warning
    }
    
    if (payload.event.item.gst_restrictions_type_id === 3 && payload.event.item.amountMaxCheck) {
      params.param1 = payload.event.item.amountMax
    }

    if (params.is_warning === null) {
      params.is_warning = 0
    }

    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {})
      .then(
        response => {
          commit('onPost', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  restrictionsPut ({commit, dispatch}, payload) {
    let url = 'api/restrictions/' + payload.event.item.id
    let params = {
      'company_id': payload.event.item.company_id,
      'gst_area_id': payload.event.item.areas,
      'core_project_id': payload.event.item.projects,
      'gst_restrictions_type_id': payload.event.item.gst_restrictions_type_id,
      'gst_category_id': payload.event.item.gst_category_id,
      'name': payload.event.item.name,
      'value': payload.event.item.value,
      'is_warning': payload.event.item.is_warning
    }
    if (params.is_warning === null) {
      params.is_warning = 0
    }
    if (params.gst_area_id === null) {
      params.gst_area_id = undefined
    }
    if (params.core_project_id === null) {
      params.core_project_id = undefined
    }

    if (payload.event.item.gst_restrictions_type_id === 3 && payload.event.item.amountMaxCheck) {
      params.param1 = payload.event.item.amountMax
    }
    
    if (payload.event.item.gst_restrictions_type_id === 7) {
      params.value = 1
      params.param3 = payload.event.item.param3
    }

    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {})
      .then(
        response => {
          commit('onPut', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  restrictionsDelete ({commit, dispatch}, payload) {
    let url = 'api/restrictions/' + payload.event.item.id
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.delete(url, {}, {})
      .then(
        response => {
          commit('onDelete', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, response: error})
        }
      )
  }
}

const mutations = {
  onGetLogged (state, payload) {
    let getLogged = payload.response.data.data
    payload.event.context.userLogged = getLogged
  },
  onCompaniesGet (state, payload) {
    let companies = payload.response.data.data
    payload.event.context.companies = companies
  },
  onCategoriesGet (state, payload) {
    let categories = payload.response.data.data
    payload.event.context.categories = categories
    payload.event.context.loadingItems = false
  },
  onRestrictionsGet (state, payload) {
    let restrictions = payload.response.data.data
    payload.event.context.restrictions = restrictions
    payload.event.context.loadingItems = false
  },
  onRestrictionTypesGet (state, payload) {
    let restrictionTypes = payload.response.data.data
    payload.event.context.restriction_types = restrictionTypes
  },
  onCurrencyGet (state, payload) {
    let currency = payload.response.data.data
    payload.event.context.currency = currency
  },
  onPaymentGet (state, payload) {
    let payment = payload.response.data.data
    payload.event.context.paymentType = payment
  },
  onPost (state, payload) {
    // let restriction = payload.response.data.data
    // let restrictions = payload.event.context.restrictions
    // restrictions.push(restriction)
    payload.event.context.refresh()
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
  },
  onPut (state, payload) {
    // let restriction = payload.response.data.data
    // let restrictions = payload.event.context.restrictions
    // restrictions.splice(payload.event.index, 1, restriction)
    payload.event.context.refresh()
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
  },
  onDelete (state, payload) {
    let restrictions = payload.event.context.restrictions
    payload.event.context.refresh()
    payload.event.context.restrictions = restrictions
    payload.event.context.close()
    payload.event.context.showNotification(payload.response, 'success')
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }

    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
  }
}

export default {
  namespaced: true,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/restrictions.js